const faqs = [
  {
    q: '911吃瓜网的内容都是真实的吗？',
    a: '我们坚持多方核实原则，每条爆料在发布前都会经过编辑团队的交叉验证。但由于信息更新速度极快，部分内容可能随事件发展而发生变化，我们会及时标注"更新中"并持续追踪最新进展。',
  },
  {
    q: '如何第一时间收到最新热点推送？',
    a: '你可以将911吃瓜网加入浏览器收藏夹，或关注我们的社交媒体账号。我们每天24小时不间断追踪全网热点，确保你打开网站就能看到今天吃瓜与今日八卦的最新汇总。',
  },
  {
    q: '可以向911吃瓜网投稿爆料吗？',
    a: '当然可以！我们欢迎每一位读者提供独家线索。你可以通过投稿邮箱或微信客服联系我们，所有投稿信息严格保密，采用后我们会标注来源并给予署名权。',
  },
  {
    q: '网站上的热度数据是如何计算的？',
    a: '热度指数综合了话题讨论量、搜索指数、社交传播度等多维度数据，由系统实时运算生成。热度榜单每24小时自动刷新，确保排名客观反映当前全网关注趋势。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-12 md:py-16 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-6 bg-primary-500 rounded-full"></span>
          <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">常见问题</h2>
          <span className="text-xs text-foreground-400">快速了解我们</span>
        </div>

        <div className="max-w-[800px] space-y-3">
          {faqs.map((faq) => (
            <details key={faq.q} className="group rounded-xl border border-background-200/70 bg-background-50">
              <summary className="flex items-center justify-between p-4 md:p-5 cursor-pointer list-none">
                <h3 className="text-sm md:text-base font-heading font-bold text-foreground-900 pr-4">{faq.q}</h3>
                <span className="flex-shrink-0 w-6 h-6 rounded-full bg-background-200 flex items-center justify-center group-open:rotate-45 transition-transform">
                  <i className="ri-add-line text-foreground-500 text-sm"></i>
                </span>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}